export default {"src":"/_next/static/media/EditIcon.ff9ca53e.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};